/**
 * Sort to items alphabetically
 * @param {String} valueA First value
 * @param {String} valueB Second value
 * @returns {0|1|-1} Array sorting values
 */
export default function (valueA, valueB) {
  if (valueA.toLowerCase() < valueB.toLowerCase()) {
    return -1
  }

  if (valueA.toLowerCase() > valueB.toLowerCase()) {
    return 1
  }

  return 0
}
